/**
 * Notify mounted Finance / ops surfaces to reload cash + AR after producer posts.
 */

export const FINANCE_POSITION_CHANGED_EVENT = "cp-finance-position-changed";

/**
 * @param {{ reason?: string, invoiceId?: string|null }} [detail]
 */
export function dispatchFinancePositionChanged(detail = {}) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(FINANCE_POSITION_CHANGED_EVENT, { detail }),
  );
}
